import React from "react";
import { Draggable } from "react-beautiful-dnd";
import EditIcon from "@mui/icons-material/Edit";
import ArchiveIcon from "@mui/icons-material/Archive";

const TaskCard = ({
  item,
  index,
  developers,
  projects,
  handleDeveloperChange,
  handleProjectChange,
  handleHoursChange,
  handleArchiveTask,
  openEditModal,
}) => {
  const timeOptions = { hour: "2-digit", minute: "2-digit" };

  const truncateText = (text, maxLength = 15) => {
    return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
  };

  // Вычисление класса подсветки в зависимости от дедлайна
  const getHighlightClass = () => {
    if (!item.deadline || item.category === "items3") return "";
    const deadlineDate = new Date(item.deadline);
    const now = new Date();
    const diffInMs = deadlineDate - now;
    const diffInHours = diffInMs / (1000 * 60 * 60);

    if (diffInHours <= 0) return "ring-2 ring-red-300"; // Просрочено
    if (diffInHours <= 12) return "ring-2 ring-yellow-200"; // Менее 12 часов
    return "";
  };

  return (
    <Draggable key={item.id} draggableId={item.id} index={index}>
      {(provided) => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          className={`bg-white w-full p-4 mb-2 rounded shadow max-w-full ${getHighlightClass()}`}
        >
          <div className="font-bold text-center break-words">{item.title}</div>
          <div className="text-sm text-gray-600 truncate-2-lines break-words">
            {item.description}
          </div>

          <div className="mt-2 flex flex-col lg:flex-row lg:items-center lg:justify-between gap-2 w-full">
            <div className="flex flex-col sm:flex-row sm:items-center gap-2 w-full md:w-2/3">
              <span className="p-1 border rounded text-xs w-full text-center break-words">
                {truncateText(
                  developers.find((dev) => dev.id === item.developer)?.name ||
                    "Назначить разработчика"
                )}
              </span>
              <span className="p-1 border rounded text-xs w-full text-center break-words">
                {truncateText(
                  projects.find((proj) => proj.id === item.project)?.name ||
                    "Без проекта"
                )}
              </span>
            </div>

            <div className="flex flex-col sm:flex-col md:flex-row items-center gap-2 w-full md:w-auto justify-between">
              <span className="p-1 border rounded w-16 text-center">
                {item.hours}
              </span>
              <div className="flex items-center space-x-2">
                {/*<button
                  onClick={() => handleArchiveTask(item._id)}
                  className="p-1 bg-red-500 text-white rounded"
                >
                  <ArchiveIcon />
                </button>*/}
                <button
                  onClick={() => openEditModal(item)}
                  className="p-1 bg-blue-500 text-white rounded"
                >
                  <EditIcon />
                </button>
              </div>
            </div>
          </div>

          {item.deadline && (
            <div className="text-xs text-gray-500 mt-1">
              Срок: {new Date(item.deadline).toLocaleDateString()}{" "}
              {new Date(item.deadline).toLocaleTimeString([], timeOptions)}
            </div>
          )}

          {item.completedAt && (
            <div className="text-xs text-gray-500 mt-1">
              Завершено: {new Date(item.completedAt).toLocaleDateString()}{" "}
              {new Date(item.completedAt).toLocaleTimeString([], timeOptions)}
            </div>
          )}
        </div>
      )}
    </Draggable>
  );
};

export default TaskCard;
